<script lang="ts">
  import type { Status } from "../../services/models"
  import StatusTag from "./StatusTag.svelte"
  import {TextArea, Code, TextField} from "@gl/design-system"

  export let status: Status;
  let code = ""
  $: {
    code = JSON.stringify(status, null, 2)
  }
</script>

<StatusTag bind:status={status}></StatusTag>
<Code>{code}</Code>